import zod from 'zod';
import { zodLimit, zodPage } from './helpers';

export const LogsSchemas = {
    LogList: zod.object({
        page: zodPage,
        limit: zodLimit(),
        sort: zod.enum(['asc', 'desc']),
        dateGte: zod.coerce.number().optional(),
        dateLte: zod.coerce.number().optional(),
        queryString: zod.string().optional(),
        userId: zod.coerce.number().optional(),
        action: zod.string().optional(),
    }),
    LogReports: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
    }),
};
